import * as React from 'react';

function Badminton(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.527 16.448L14.11 6.203l2.834.851.84 2.797-10.258 6.597zm-1.754-.676a.862.862 0 01-.226-.803l.026-.096L9.468 3.614c.221-.64 1.035-.817 1.476-.352l.058.068 1.69 2.19-6.719 10.453-.2-.201zM8 17.999l10.448-6.715 2.221 1.714c.498.384.411 1.143-.109 1.453l-.082.044-.092.037-11.26 3.895a.87.87 0 01-.824-.135l-.074-.065-.227-.228H8zm-4.314 2.315a2.344 2.344 0 010-3.315l.553-.552 3.314 3.314-.552.553a2.344 2.344 0 01-3.315 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Badminton;
